import { render, staticRenderFns } from "./CartsDrawer.vue?vue&type=template&id=49789448"
import script from "./CartsDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartsDrawer.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CartsDrawerHeader: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/carts/CartsDrawerHeader.vue').default,CartsCartItemsList: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/carts/CartItemsList.vue').default,CartsList: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/carts/CartsList.vue').default,CartsDrawerFooter: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/carts/CartsDrawerFooter.vue').default,CartsDrawerLayout: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/carts/CartsDrawerLayout.vue').default,CNavigationDrawer: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CNavigationDrawer/CNavigationDrawer.vue').default,CartsNotification: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/carts/CartsNotification.vue').default})
